import React from 'react';
import { Button, Card, Empty, Space, Typography } from 'antd';
import { UpOutlined, DownOutlined, PlusOutlined } from '@ant-design/icons';
import ProposalItem from '../../pages/proposals/ProposalItem';

const { Text } = Typography;

const ProposalItemsList = ({
  items,
  products,
  languages,
  proposalCurrency,
  onItemChange,
  onItemBlur,
  onDeleteItem,
  onDrop,
  onRemoveImage,
  onReorderImages,
  onReorderItems,
  onUpdateImageDescription,
  onAddItem,
  proposalId,
  validationErrors = {},
}) => {
  return (
    <Card
      title="Line items"
      data-testid="proposal-items-list"
      style={{ marginBottom: 24 }}
      extra={
        onAddItem ? (
          <Button
            type="dashed"
            size="small"
            icon={<PlusOutlined />}
            onClick={onAddItem}
          >
            Add Item
          </Button>
        ) : null
      }
    >
      {items.length === 0 ? (
        <Empty
          image={Empty.PRESENTED_IMAGE_SIMPLE}
          description="No items yet. Add a product or custom item to get started."
        >
          {onAddItem && (
            <Button type="primary" icon={<PlusOutlined />} onClick={onAddItem}>
              Add Item
            </Button>
          )}
        </Empty>
      ) : (
        items.map((item, index) => (
          <div
            key={
              item.tempKey ||
              (item.proposal_item_id != null
                ? `existing-${item.proposal_item_id}`
                : `item-${index}`)
            }
            className="proposal-item-wrapper d-flex mb-3"
            style={{ alignItems: 'flex-start', gap: 8 }}
          >
            {onReorderItems && (
              <div
                style={{
                  flexShrink: 0,
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  paddingTop: 8,
                  zIndex: 1,
                }}
              >
                <Text
                  type="secondary"
                  style={{ fontSize: 11, lineHeight: 1, marginBottom: 2 }}
                >
                  #{index + 1}
                </Text>
                <Space direction="vertical" size={0}>
                  <Button
                    type="text"
                    size="small"
                    htmlType="button"
                    icon={<UpOutlined />}
                    disabled={index === 0}
                    onClick={(e) => {
                      e.preventDefault();
                      e.stopPropagation();
                      onReorderItems(index, index - 1);
                    }}
                    title="Move up"
                    aria-label={`Move item ${index + 1} up`}
                  />
                  <Button
                    type="text"
                    size="small"
                    htmlType="button"
                    icon={<DownOutlined />}
                    disabled={index === items.length - 1}
                    onClick={(e) => {
                      e.preventDefault();
                      e.stopPropagation();
                      onReorderItems(index, index + 1);
                    }}
                    title="Move down"
                    aria-label={`Move item ${index + 1} down`}
                  />
                </Space>
              </div>
            )}
            <div className="flex-grow-1" style={{ minWidth: 0 }}>
              <ProposalItem
                index={index}
                item={item}
                products={products}
                languages={languages}
                proposalCurrency={proposalCurrency}
                handleItemChange={onItemChange}
                handleItemBlur={onItemBlur}
                handleDeleteItem={onDeleteItem}
                handleDrop={onDrop}
                handleRemoveImage={onRemoveImage}
                handleReorderImages={onReorderImages}
                handleUpdateImageDescription={onUpdateImageDescription}
                proposalId={proposalId}
                validationError={validationErrors[index]}
              />
            </div>
          </div>
        ))
      )}
    </Card>
  );
};

export default ProposalItemsList;
